import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../imageWithBasePath'
import { all_routes } from '../../../feature-module/router/all_routes'
import "./footer.css";
const Footer = () => {

  const routes = all_routes

  return (
    <>
      {/* Footer */}
      <footer>
        <div className="container">
          <div className="footer-top">
            <div className="row row-cols-lg-5 row-cols-md-3 row-cols-sm-2 row-cols-2">
              <div className="col">
                <div className="footer-widget">
                  <h5>Pages</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to={routes.teams}>Our Team</Link>
                    </li>
                    <li>
                      <Link to={routes.Gallery}>Gallery</Link>
                    </li>
                    <li>
                      <Link to={routes.myProfile}>Profile</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-widget">
                  <h5>Company</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to={routes.about_us}>About Us</Link>
                    </li>
                    <li>
                      <Link to="#">Careers</Link>
                    </li>
                    <li>
                      <Link to={routes.blogGrid}>Blog</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-widget">
                  <h5>Destinations</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to="#">Hawai</Link>
                    </li>
                    <li>
                      <Link to="#">Istanbul</Link>
                    </li>
                    <li>
                      <Link to="#">San Diego</Link>
                    </li>
                    <li>
                      <Link to="#">Belgium</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-widget">
                  <h5>Support</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to={routes.contactUs}>Contact Us</Link>
                    </li>
                    <li>
                      <Link to={routes.privacyPolicy}>Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to={routes.termsConditions}>Terms and Conditions</Link>
                    </li>
                    <li>
                      <Link to="#">Refund Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-widget">
                  <h5>Services</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to={routes.hotelGrid}>Hotel Booking</Link>
                    </li>
                    <li>
                      <Link to="#">Activity Finder</Link>
                    </li>
                    <li>
                      <Link to={routes.flightGrid}>Flight Booking</Link>
                    </li>
                    <li>
                      <Link to={routes.tourDetails}>Holiday Packages</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-wrap bg-white w-100 py-3 border-top">
              <div className="container">
                <div className="row align-items-center gx-0">

                  {/* Column 1: Logo */}
                  <div className="col-12 col-sm-6 col-md-3 text-center text-md-start mb-3 mb-md-0">
                    <Link to={routes.home1} className="d-inline-block">
                      <ImageWithBasePath
                        src="assets/img/logo.png"
                        alt="logo"
                        style={{ maxWidth: "140px", height: "auto", display: "block" }}
                      />
                    </Link>
                  </div>

                  {/* Column 2: Available on + two stacked store badges */}
                  <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
                    <div className="d-flex flex-column align-items-center align-items-md-start">
                      <p className="mb-1 fw-semibold">Available on</p>

                      {/* Row 1: Google Play */}
                      <div className="d-block mb-2">
                        <Link to="#" className="d-inline-block">
                          <ImageWithBasePath
                            src="assets/img/icons/googleplay.svg"
                            alt="Google Play"
                            style={{ height: "36px", width: "auto", display: "block" }}
                          />
                        </Link>
                      </div>

                      {/* Row 2: App Store */}
                      <div className="d-block">
                        <Link to="#" className="d-inline-block">
                          <ImageWithBasePath
                            src="assets/img/icons/appstore.svg"
                            alt="App Store"
                            style={{ height: "36px", width: "auto", display: "block" }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* Column 3: Customer Support + two phone numbers (each no-break) */}
                  <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
                    <div className="d-flex flex-column align-items-center align-items-md-start">
                      <div className="d-flex align-items-center mb-2">
                        <span className="avatar avatar-md bg-primary rounded-circle d-flex align-items-center justify-content-center me-2">
                          <i className="ti ti-headphones-filled fs-18 text-white" />
                        </span>
                        <p className="mb-0 fw-semibold">Customer Support</p>
                      </div>

                      {/* phone rows - use text-nowrap / no-break to prevent line breaks */}
                      <div>
                        <p className="mb-0 small text-dark no-break">0471-3520890</p>
                        <p className="mb-0 small text-dark no-break">0471-4011121</p>
                      </div>
                    </div>
                  </div>

                  {/* Column 4: Email header + email (no-break) */}
                  <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
                    <div className="d-flex flex-column align-items-center align-items-md-start">
                      <div className="d-flex align-items-center mb-2">
                        <span className="avatar avatar-md bg-secondary rounded-circle d-flex align-items-center justify-content-center me-2">
                          <i className="ti ti-message fs-18 text-white" />
                        </span>
                        <p className="mb-0 fw-semibold">Drop Us an Email</p>
                      </div>

                      <div>
                        <p className="mb-0 small text-dark no-break">contact@triointernational.net.in</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>


            <div className="footer-img">
              <ImageWithBasePath src="assets/img/bg/footer.svg" className="img-fluid" alt="img" />
            </div>
          </div>
        </div>
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <p className="fs-14">
                    Copyright © 2025. All Rights Reserved,{" "}
                    <Link
                      to="#"
                      className="text-primary fw-medium"
                    >
                      Trio International
                    </Link>
                  </p>
                  <div className="d-flex align-items-center">
                    <ul className="social-icon">
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-x-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-instagram" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-pinterest" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <ul className="card-links">
                    <li>
                      <Link to="#">
                        <ImageWithBasePath src="assets/img/icons/card-01.svg" alt="img" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath src="assets/img/icons/card-02.svg" alt="img" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath src="assets/img/icons/card-03.svg" alt="img" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath src="assets/img/icons/card-04.svg" alt="img" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath src="assets/img/icons/card-05.svg" alt="img" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath src="assets/img/icons/card-06.svg" alt="img" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Footer Bottom */}
      </footer>
      {/* /Footer */}
    </>

  )
}

export default Footer